export default __webpack_public_path__ + "static/media/Bottom_appointment.77b0f143.svg";